import React, { useRef, useState, useEffect } from 'react';
import { useDrag, useDrop, useDragDropManager } from 'react-dnd';
import { v4 as uuid } from 'uuid';
import Item from './Item'
import { useQuery, useMutation, useQueryClient } from 'react-query'
import { fetchBox, addChild, deleteThing, updateThing } from './queries';

function Box({ id, className, parent, ...props }) {
    const queryClient = new useQueryClient()
    const invalSelf = () => queryClient.invalidateQueries(['box', id])
    const updateSelf = (data) => queryClient.setQueryData(['box', id], data)

    const updateAction = useMutation(updateThing, {
        onSuccess: updateSelf,
    })

    const addChildAction = useMutation(addChild, {
        onSuccess: invalSelf,
    })

    const deleteAction = useMutation(deleteThing, {
        onSuccess: () => {
            queryClient.invalidateQueries(['box', parent])
        },
    })

    const { isLoading, error, data } = useQuery(['box', id], () => fetchBox(id, parent))

    const [{ isDragging }, drag, dragPreview] = useDrag(() => ({
        type: 'BOX',
        item: { id, className },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult()
            if (item && dropResult) {
                alert(`You dropped ${item.id} into ${dropResult.name}!`)
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        })
    }))

    const [{ canDrop, isOver }, drop] = useDrop(() => ({
        // The type (or types) to accept - strings or symbols
        accept: props.holds || ['BOX', 'ITEM'],
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop()
        })
    }))

    useEffect((data) => {
        console.log(`ID: ${id} updated`)
    })

    if (isLoading) return <div className='box'>Loading...</div>

    if (error) return <div className='box'>An error has occurred: {error.message}</div>

    function toggleHolds() {
        updateAction.mutate({
            id: id, data: { holds: data.holds == "BOX" ? "ITEM" : "BOX" }
        })
    }

    function updateTitle(event) {
        updateAction.mutate({
            id: id, data: { title: event.target.value }
        })
    }

    function deleteSelf() {
        deleteAction.mutate(id)
    }
    function addBox() {
        addChildAction.mutate({ parent: id, id: 'b' + uuid() })
    }
    function addItem() {
        addChildAction.mutate({ parent: id, id: 'i' + uuid() })
    }

    return (
        <div className={"box " + className} ref={dragPreview} style={{ opacity: isDragging ? 0.5 : 1 }}>
            <div className="control-bar" ref={drag} >
                {data.holds == "BOX" ?
                    <div onClick={addBox}>Add Box</div>
                    :
                    <div onClick={addItem}>Add Item</div>
                }
                {
                    !data.children.length &&
                    <div onClick={toggleHolds}>Toggle Type</div>
                }
                <div>Options</div>
                <div onClick={deleteSelf}>Delete Box</div>
            </div >
            <input className='title' value={data.title} onChange={updateTitle}></input>
            {data.children.map((thing) =>
                data.holds == "BOX" ?
                    <Box holds="ITEM" key={thing} id={'b' + thing} parent={id} />
                    :
                    <Item key={thing} id={'i' + thing} parent={id} />
            )}
            <div
                ref={drop}
                role={'Dustbin'}
                style={{ backgroundColor: isOver ? 'red' : 'white' }}
            >
                {canDrop ? 'Release to drop' : 'Drag a box here'}
            </div>
        </div >
    )
}

export default Box